import React from "react";
import Link from "next/link";

export default function NoUserFoundScreen() {
  return (
    <>
      <div className="bg-[#21252A] w-full fixed top-0">
        <div className="flex-1 flex justify-center items-center py-2 lg:my-0">
          <Link href="/">
            <img
              src="/images/Logo-white.png"
              className="h-12 lg:h-12 cursor-pointer"
              alt="Snacktime"
            />
          </Link>
        </div>
      </div>
      <div className="w-full h-screen flex items-center justify-center">
        <span className="text-3xl px-4 text-center">
          Sorry, we couldn’t find the user you were looking for.
        </span>
      </div>
    </>
  );
}
